import React from 'react';

import classNames from 'classnames';

import { CircularProgress } from '@vk-hr-tek/ui/CircularProgress';
import { Link } from '@vk-hr-tek/ui/Link';

/**
 * Интерфейс, представляющий свойства для компонента Chat.
 *
 * @interface ChatProps
 * @property {'idle' | 'loading' | 'complete' | 'failed'} status - Текущий статус чата.
 * @property {() => void} loadWebim - Функция для загрузки чата WebIM.
 */

interface ChatProps {
  status: 'idle' | 'loading' | 'complete' | 'failed';
  loadWebim: () => void;
}

/**
 * Компонент, отображающий кнопку чата с различными состояниями (idle, loading, complete, failed).
 * Включает индикатор загрузки и может вызывать функцию загрузки чата WebIM при клике.
 *
 * @component
 * @param {ChatProps} props - Свойства для компонента Chat.
 * @param {'idle' | 'loading' | 'complete' | 'failed'} props.status - Текущий статус чата.
 * @param {() => void} props.loadWebim - Функция для загрузки чата WebIM.
 * @returns {JSX.Element} Компонент Chat.
 */

export const Chat = ({ status, loadWebim }: ChatProps) => {
  const isLoading = status === 'loading';
  const isComplete = status === 'complete';

  return (
    <>
      {(isLoading || isComplete) && (
        <Link
          className={classNames(
            'webim_button',
            'hidden',
            'vkdoc_webim_loaded',
            'aqa_chat_link',
          )}
          onClick={() => {}}
        >
          <img
            alt="webim"
            src={`https://${window.REACT_APP_VKHRTEK_WEBIM_ACCOUNT_NAME}.webim.ru/button.php`}
          />
        </Link>
      )}

      <Link
        className={classNames(
          'webim_button',
          'webim_button_no_loaded',
          'aqa_chat_link',
          isLoading && 'webim_button_loading',
        )}
        onClick={loadWebim}
      >
        {isLoading && <CircularProgress size={30} />}
      </Link>
    </>
  );
};
